import Form from '../_form';

const [ REDIRECTION_TIMEOUT, REDIRECTION_PATH ] = [ 3000, `${window.location.origin}/auth/sign-in` ];

export default class ChangePasswordForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const form = document.querySelector(query);
        if (!form) return;

        const pending = document.querySelector('#change-password-pending');
        if (!pending) throw new Error('Change password pending element not found!');

        const success = document.querySelector('#change-password-success');
        if (!success) throw new Error('Change password success element not found!');

        this.success = success;
        this.pending = pending;
    }

    handleSuccess () {
        this.form.classList.add('hidden');
        this.success.classList.remove('hidden');
        this.pending.classList.add('hidden');
    }

    handlePending () {
        this.form.classList.add('hidden');
        this.pending.classList.remove('hidden');
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const token = formData.get('token');
        const password = formData.get('password');

        this.handlePending();

        try {
            await fetch('/wp-json/user/v1/change-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token, password })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Successfully sent!', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.handleSuccess();

                    setTimeout(() => window.location.href = REDIRECTION_PATH, REDIRECTION_TIMEOUT);
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
